import axios from "axios";
import { apiPortal } from "../../config";
const point = apiPortal + "/majalah";
const Majalah = {
    async getData(page = 1) {
        try {
            const data = await axios.get(point, {
                params: {
                    page: page,
                },
            });
            return data.data;
        } catch (error) {
            if (errro.response) {
                throw error.response.data.message;
            }
            throw error;
        }
    },
    async getById(id) {
        try {
            const data = await axios.get(`${point}/${id}/detail`);
            return data.data;
        } catch (error) {
            if (errro.response) {
                throw error.response.data.message;
            }
            throw error;
        }
    },
};
export default Majalah;